import React from "react";

const GalleryV = ({ arrayFoto, titoloGallery }) => {
  return (
    <div className="photogallery-wrapper pg_v">
      <div className="photogallery">
        {arrayFoto.map((pic, chiave) => {
          return (
            <div className="arrayFoto_item" key={chiave}>
              <a href={`/gallery/${pic}.jpg`} data-fancybox="gallery">
                <img src={`/gallery/${pic}.jpg`} />
              </a>
            </div>
          );
        })}
      </div>
      {titoloGallery && <div className="photogallery-title">{titoloGallery}</div>}
    </div>
  );
};

export default GalleryV;
